import { useAtomValue } from 'jotai'
import React from 'react'

import { brandGroupIdAtom } from '~/atoms'
import { useSurveyQueryAvailableBrandGroups } from '~/hooks/useSurveyQuery'

import { tabulatedBrandIdsAtom } from '../atoms'

export const useSelectedBrands = () => {
  const brandGroups = useSurveyQueryAvailableBrandGroups()

  const brandGroupId = useAtomValue(brandGroupIdAtom)
  const brandIds = useAtomValue(tabulatedBrandIdsAtom)

  return React.useMemo(
    () =>
      brandGroups
        .find((brandGroup) => brandGroup.id === brandGroupId)
        ?.brands.filter((brand) => brandIds.includes(brand.id)) ?? [],
    [brandGroupId, brandGroups, brandIds],
  )
}
